<template>
  <el-dialog id="connect-repository" class="align-center" :visible.sync="visible">
    <div class="buttons">
      <el-button
        type="primary"
        icon="mdi mdi-github"
        :loading="loading.github"
        @click="popup.github = true"
      >
        Connect from Github
      </el-button>

      <el-divider>runstack repositories</el-divider>

      <Filters class="filters" placeholder="Search by name" />

      <el-table
        :data="repositories"
        size="mini"
      >
        <el-table-column>
          <template slot-scope="scope">
            <img
              :src="regionFlag(getInstance(scope.row.instanceId).planId)"
              class="flag"
              @click="$router.push('/instances/' + scope.row.instanceId)"
            />

            <el-button
              type="text"
              size="mini"
              @click="$router.push('/instances/' + scope.row.instanceId)"
            >
              {{ getInstance(scope.row.instanceId).name }}
            </el-button> /

            {{ scope.row.name }}
          </template>
        </el-table-column>

        <el-table-column align="right">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.id === repositoryId"
              type="primary"
              size="small"
              :disable-transitions="true"
            >
              <i class="el-icon-check" /> Selected
            </el-tag>

            <el-button
              v-else
              type="primary"
              size="mini"
              @click="repositoryId = scope.row.id"
            >
              Choose
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <Github
      :open.sync="popup.github"
      :application-id="applicationId"
      :loading.sync="loading.github"
      append-to-body
      @change="visible = false"
    />

    <div slot="footer">
      <el-button
        type="default"
        size="large"
        @click="visible = false"
      >
        Cancel
      </el-button>

      <el-button
        type="primary"
        size="large"
        :loading="loading.connect"
        :disabled="!repositoryId"
        @click.prevent="connect"
      >
        Connect
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import Github from './Github'
import Filters from '../Filters'

export default {
  props: {
    instance: Object,
    applicationId: String,
    connectType: String,
    open: Boolean
  },
  components: {
    Github,
    Filters
  },
  data () {
    return {
      visible: this.open,
      repositoryId: null,
      loading: {
        github: false,
        connect: false
      },
      popup: {
        github: false
      }
    }
  },
  created () {
    if (this.connectType === 'github') {
      this.popup.github = true
      this.$router.replace(this.$route.path)
    }
  },
  computed: {
    data () {
      return this.repositories.filter((r) => r.state !== 'external')
    },
    ...mapState(['repositories', 'instances'])
  },
  methods: {
    getInstance (instanceId) {
      return this.instances.find((i) => i.id === instanceId)
    },
    connect () {
      this.loading.connect = true
      this.$store.dispatch('connectRepository', {
        id: this.repositoryId,
        applicationId: this.applicationId
      }).then(() => {
        this.visible = false
        this.$emit('change')
      }).catch(() => {
        this.loading.connect = false
      })
    }
  },
  watch: {
    open (value) {
      this.repositoryId = null
      this.loading.connect = false
      this.visible = value
    },
    visible (value) {
      this.$nextTick(() => this.$emit('update:open', value))
    },
    'popup.github' (value) {
      this.loading.github = value
    }
  }
}
</script>

<style lang="scss">
  #connect-repository .el-dialog {
    min-width: 600px;

    .el-dialog__body {
      padding-right: 0;
      padding-left: 0;

      .el-table__row td:first-child {
        padding-left: 10px;
      }
      .el-table__row td:last-child {
        padding-right: 10px;
      }
    }

    .el-button--text.el-button--medium {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
</style>

<style lang="scss" scoped>
  @import "../../theme";

  .buttons {
    padding: 25px 0;

    .el-divider {
      margin: 50px 0 30px;
    }
  }
  .filters {
    margin: 0 20px 0;
  }
  .flag {
    height: 15px;
    float: left;
    margin: 7px 5px 0 0;
    cursor: pointer;
  }
</style>
